module.exports = __webpack_public_path__ + "img/discount_banner.2411053c.png";